import SprievodnyDokumentUpdateList from './SprievodnyDokumentUpdateList';

export default SprievodnyDokumentUpdateList;
